import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';

// Dynamic import to prevent tree-shaking
async function enableMocking() {
  const mockEnabled = import.meta.env.VITE_ENABLE_MOCK_DATA === 'true';
  
  if (mockEnabled) {
    const { startMockServiceWorker } = await import('./mocks');
    await startMockServiceWorker();
  }
}

enableMocking().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
